import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import InlineModal from '../shared/InlineModal';
import HowToFix from '../shared/HowToFix';

export default function StructuredDataSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {result.status === 'passed' && result.structured_data && <StructuredDataResult structuredData={result.structured_data} />}

                {result.status !== 'passed' && result.how_to_fix && (
                    <HowToFix
                        title={title}
                        howToFix={result.how_to_fix}
                        howToFixVideo={result.how_to_fix_video}
                    />
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type StructuredDataResultProps = {
    structuredData: {
        type: string;
        properties: {
            [key: string]: string;
        }[];
    }[];
};

function StructuredDataResult({ structuredData }: StructuredDataResultProps) {
    return (
        <div className="description-meta">
            <InlineModal
                openLabel="See all microdata objects"
                modalTitle="Full list of structured data objects"
                closeLabel="Close"
            >
                <ul className="bulleted-list">
                    {structuredData.map((item, index) => (
                        <React.Fragment key={index}>
                            <li>
                                <strong>type: </strong>
                                {item.type}
                            </li>
                            <li>
                                <strong>properties: </strong>
                            </li>
                            {Object.entries(item.properties).map(([key, value]) => {
                                return (
                                    <li
                                        style={{ marginLeft: '40px' }}
                                        key={`${key}-${index}`}
                                    >
                                        <strong>{key}: </strong>
                                        {value}
                                    </li>
                                );
                            })}
                        </React.Fragment>
                    ))}
                </ul>
            </InlineModal>
        </div>
    );
}
